export default "__VITE_ASSET__CujTS2oW__"